import React, { useState } from "react";
import { MessageCircle, Phone, Mail, X } from "lucide-react";

const WHATSAPP_NUMBER = "918800288994";
const CALL_NUMBER = "+918800288994";
const EMAIL = "info@kikicentre.com";

// Custom WhatsApp icon (lucide doesn't ship a brand mark for WhatsApp)
function WhatsAppIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
    </svg>
  );
}

export default function FloatingActions() {
  const [open, setOpen] = useState(false);

  const actions = [
    {
      icon: WhatsAppIcon,
      label: "WhatsApp",
      sub: "Chat with us",
      href: `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hello Kiki Centre, I would like to know more about your courses.")}`,
      color: "bg-[#25D366]",
      textColor: "text-white",
      target: "_blank",
    },
    {
      icon: Phone,
      label: "Call Us",
      sub: "+91 8800288994",
      href: `tel:${CALL_NUMBER}`,
      color: "bg-[#0B2A6B]",
      textColor: "text-yellow-400",
    },
    {
      icon: Mail,
      label: "Email",
      sub: EMAIL,
      href: `mailto:${EMAIL}?subject=${encodeURIComponent("Course Enquiry")}`,
      color: "bg-yellow-400",
      textColor: "text-[#0B2A6B]",
    },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-[70] flex flex-col items-end gap-3">
      {/* Action sheet */}
      <div
        className={`flex flex-col items-end gap-3 transition-all duration-300 ${
          open ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        {actions.map((a, i) => (
          <a
            key={a.label}
            href={a.href}
            target={a.target}
            rel={a.target === "_blank" ? "noreferrer" : undefined}
            className={`group flex items-center gap-3 pl-4 pr-2 py-2 rounded-full shadow-lg hover:shadow-xl ${a.color} ${a.textColor} transition transform hover:-translate-x-1`}
            style={{ transitionDelay: `${i * 0.04}s` }}
          >
            <div className="text-right">
              <div className="text-xs font-bold leading-tight">{a.label}</div>
              <div className="text-[10px] opacity-90 leading-tight">{a.sub}</div>
            </div>
            <div className="h-10 w-10 rounded-full bg-white/15 flex items-center justify-center">
              <a.icon className="h-5 w-5" />
            </div>
          </a>
        ))}
      </div>

      {/* Main toggle button */}
      <button
        onClick={() => setOpen(!open)}
        aria-label="Contact options"
        className="relative h-14 w-14 rounded-full bg-yellow-400 hover:bg-yellow-500 text-[#0B2A6B] shadow-2xl flex items-center justify-center transition transform hover:scale-110"
      >
        {!open && (
          <span className="absolute inset-0 rounded-full bg-yellow-400 animate-ping opacity-40" />
        )}
        <span className="relative">
          {open ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6 fill-current" />}
        </span>
      </button>
    </div>
  );
}
